import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      title: "Klassische WEG-Verwaltung",
      description: "Professionelle Verwaltung kleiner bis mittlerer Wohnungseigentümergemeinschaft mit persönlichem Ansprechpartner.",
      features: [
      "Pflichtverwaltung gemäß WEG-Reform 2024",
      "Organisation und Protokollierung von Eigentümerversammlungen",
      "Vertrags- und Versicherungsmanagement",
      "Transparente Hausgeldabrechnung und Wirtschaftsplan",
      "Kommunikation mit Dienstleistern und Eigentümern"
      ],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      )
    },
    {
      title: "Digitale Plattform",
      description: "Moderne Online-Tools für transparente und effiziente Verwaltung.",
      features: [
      "DSGVO-konformes Dokumentenarchiv (Hosting in Deutschland)",
      "Echtzeit-Zugriff auf Abrechnungen, Beschlüsse und Pläne",
      "Digitale Eigentümerversammlungen",
      "Sichere, verschlüsselte Kommunikation",
      "Echtzeit-Updates und Benachrichtigungen"
      ],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      title: "Sanierungsmanagement",
      description: "Professionelle Begleitung bei Modernisierungs- und Sanierungsprojekten.",
      features: [
        "Projektplanung und -koordination",
        "Kostenschätzung und Budgetierung",
        "Handwerkerkoordination und Qualitätskontrolle",
        "Berichtswesen gegenüber der WEG",
        "Predictive Analytics für technische Anlagen"
      ],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      title: "Finanzmanagement",
      description: "Zuverlässige Verwaltung der Finanzen Ihrer Eigentümergemeinschaft.",
      features: [
      "Transparente Hausgeldabrechnungen",
      "Verwaltung der Rücklagen nach §28 WEG",
      "Zahlungsüberwachung und Mahnwesen",
      "Jährliche Wirtschaftsplanung",
      "Individuelle Kostenverteilung nach Miteigentumsanteilen"
      ],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
        </svg>
      )
    },
    {
      title: "WEG Softwareberatung",
    description: "Individuelle Unterstützung bei Auswahl, Einrichtung und Nutzung moderner Hausverwaltungssoftware.",
    features: [
      "Beratung zur passenden Softwarelösung für Ihre WEG-Verwaltung",
      "Begleitung bei Digitalisierung selbstverwalteter WEGs",
      "Beratung bei der Einrichtung von Tools",
      "Integration von KI-gestützten Workflows",
      "Schulung von Verwaltern, Beiräten und Eigentümern im Umgang mit Software"
      ],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17h4.5m-2.25 0v2m-8.25-6V5a2 2 0 012-2h12a2 2 0 012 2v8m-16.5 0h16.5m-16.5 0v4a2 2 0 002 2h12a2 2 0 002-2v-4" />
</svg>

      )
    },
    {
      title: "Mieterverwaltung",
      description: "Professionelle Verwaltung von Mietobjekten mit modernen digitalen Tools und persönlicher Betreuung.",
      features: [
        "Mieterbetreuung und Kommunikation",
        "Mietinkasso und Nebenkostenabrechnungen", 
        "Instandhaltungsmanagement",
        "Leerstandsminimierung",
        "Rechtssichere Mietverträge und Kündigungen"
      ],
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-secondary to-primary text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Unsere Leistungen
          </h1>
          <p className="text-xl max-w-3xl mx-auto">
            Von klassischer WEG-Verwaltung bis hin zu modernster KI-Technologie - 
            wir bieten Ihnen ein umfassendes Paket für die professionelle Verwaltung 
            Ihrer Wohnungseigentümergemeinschaft.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="card group hover:scale-105 transition-transform duration-300">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mb-6 group-hover:bg-secondary transition-colors duration-200">
                  <div className="text-white">
                    {service.icon}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-secondary mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start space-x-2">
                      <div className="flex-shrink-0 w-4 h-4 bg-secondary-light rounded-full flex items-center justify-center mt-1">
                        <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                      </div>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="py-20 bg-background-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4">
              Moderne Technologie für traditionelle Werte
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Wir verbinden bewährte Verwaltungsmethoden mit innovativer Technologie 
              für optimale Ergebnisse.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary mb-2">DSGVO-konform</h3>
              <p className="text-gray-600 text-sm">Alle Daten werden streng nach deutschen Datenschutzrichtlinien verarbeitet.</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary mb-2">Deutsches Hosting</h3>
              <p className="text-gray-600 text-sm">Alle Server stehen ausschließlich in deutschen Rechenzentren.</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-secondary-light rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary mb-2">KI-gestützt</h3>
              <p className="text-gray-600 text-sm">Künstliche Intelligenz optimiert Ihre Verwaltungsprozesse.</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary mb-2">Sicher & Verschlüsselt</h3>
              <p className="text-gray-600 text-sm">Ende-zu-Ende Verschlüsselung für maximale Datensicherheit.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Bereit für die nächste Stufe der WEG-Verwaltung?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Lassen Sie uns gemeinsam Ihre Verwaltung modernisieren und 
            von unseren innovativen Lösungen profitieren.
          </p>
          <Link to="/kontakt" className="bg-white text-primary px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 inline-block">
            Jetzt ein individuelles Angebot einholen
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services; 